import { useState } from 'react';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';
import { MeatballMenu, MenuItem } from '#components/patterns/menus/meatball-menu/index.ts';
import type { Admin } from '#dn-types/admin.ts';
import { DeleteAdminDialog } from '../delete/DeleteAdminDialog.tsx';

type Props = {
  admin: Admin;
  currentUserEmail: string;
};

export function AdminsActionMenu({ admin, currentUserEmail }: Props) {
  const [isDeleting, setIsDeleting] = useState(false);
  const isSelf = admin.email === currentUserEmail;

  return (
    <>
      <MeatballMenu>
        {isSelf ?
          <Tooltip content="You may not remove yourself">
            <MenuItem disabled>Remove</MenuItem>
          </Tooltip>
        : <MenuItem
            onClick={() => {
              setIsDeleting(true);
            }}
          >
            Remove
          </MenuItem>
        }
      </MeatballMenu>
      {isDeleting ?
        <DeleteAdminDialog
          admin={admin}
          onDelete={() => {
            setIsDeleting(false);
          }}
          onCancel={() => {
            setIsDeleting(false);
          }}
        />
      : null}
    </>
  );
}
